
import axios from "axios";
const API_URL = process.env.REACT_APP_API;

export const obtenerPedidosPorEtapa = async (filter: any) => {
  try {

    const { campo_id, valor } = filter;
    const data_filter = {
        campo_id, valor
    }
    const response = await axios.post(`${API_URL}pedidos/all/filtros`, data_filter);
    const pedidos = response.data.doc.data;
    const pedidosPorEtapa = pedidos.map((item: any) => {
      const tarjetas = item.items.map((element: any) => {
        return {
          ...element,
          draggable: item.code === "PED_PAID" ? false : true,
          laneId: element.etapa.id,
        };
      })
      return {
        id: item.code,
        etapa_id: item.etapaId,
        title: item.nombre,
        code: item.code,
        color_etapa: item.color,
        monto_total_mxn: item.monto_total_mxn,
        monto_total_usd: item.monto_total_usd,
        label: 1,
        style: { width: 300 },
        currentPage: 1,
        disallowAddingCard: true,
        cards: tarjetas,
      }
    });
    return {
      pedidos,
      pedidosPorEtapa
    };
  } catch (error) {
    console.error("Error al obtener los pedidos:", error);
    throw error;
  }
};

export async function obtenerCamposFiltroPedidos() {
  try {

    const response = await axios.get(`${API_URL}catalogs/campos/TBL_PEDIDO`);
    const data = response.data.doc.data;
    const campos = data.filter((option: any) => option.code !== "PED_ETP" && option.code !== "PED_COB_ASIG");
    return campos;

  } catch (error) {
    console.error("Error al obtener los campos a filtrar:", error);
    throw error;
  }
}

export async function obtenerDatosFiltrosPedidos(code: string) {
  try{

    let response;
    let data;
    let res;
    let selectOptions;

    switch (code) {
        case 'PED_NOMBRE':
            response = await axios.get(`${API_URL}pedidos/`);
            res = response.data.doc.data;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.nombre,
            }));
            data = selectOptions;
            break;
        case 'PED_FOLIO':
           response = await axios.get(`${API_URL}pedidos/`);
            res = response.data.doc.data;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.folio,
            }));
            data = selectOptions;
            break;
        case 'PED_UNEG':
            response = await axios.get(`${API_URL}catalogs/UNEG/`);
            res = response.data.doc.data.rows;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.name,
            }));
            data = selectOptions;
            break;
        case 'PED_STS':
            response = await axios.get(`${API_URL}catalogs/STS_PEDIDO/`);
            res = response.data.doc.data.rows;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.name,
            }));
            data = selectOptions;
            break;
        case 'PED_ACC':
          response = await axios.post(`${API_URL}catalogos/cuentas?sort=nombre`, {
            field_id: null,
            field_value: null,
          });
          res = response.data.doc.data.rows;
          selectOptions = res.map((option: any) => ({
            value: option.id,
            label: option.nombre,
          }));
          data = selectOptions;
            break;
        case 'PED_VEND_ASIG':
          response = await axios.get(`${API_URL}catalogos/vendedores/list/comerciales`);
          res = response.data.doc.data.rows;
          selectOptions = res.map((option: any) => ({
            value: option.id,
              label: `${option.nombre} ${option.apellido_paterno}`,
          }));
          data = selectOptions;
            break;
        case 'PED_COB_ASIG':
          response = await axios.get(`${API_URL}catalogs/TIPO_PAGO/`);
          res = response.data.doc.data.rows;
          selectOptions = res.map((option: any) => ({
            value: option.id,
            label: option.name,
          }));
          data = selectOptions;
            break;
        case 'PED_TIPO':
          response = await axios.get(`${API_URL}catalogs/TPED/`);
          res = response.data.doc.data.rows;
          selectOptions = res.map((option: any) => ({
            value: option.id,
            label: option.name,
          }));
          data = selectOptions;
            break;
        case 'PED_TIPO_COT':
          response = await axios.get(`${API_URL}catalogs/TOP/`);
           res = response.data.doc.data.rows;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.name,
            }));
            data = selectOptions;
            break;
        // case 'PED_ETP':
        //   response = await axios.get(`${API_URL}catalogs/EPED/`);
        //   res = response.data.doc.data.rows;
        //   selectOptions = res.map((option: any) => ({
        //     value: option.id,
        //     label: option.name,
        //   }));
        //   data = selectOptions;
        //     break;
        default:  
            break;
    }
    return data;

  } catch (error) {
    console.error("Error al obtener los campos a filtrar:", error);
    throw error;
  }

}


export async function actualizarEtapaPedidos( values: any ) {
  try {
    const { id, etapaCode } = values;
    let data = {
      pedido_id: id,
      etapa_code: etapaCode
    }
    const response = await axios.patch(`${API_URL}pedidos/cambiar/etapa`, data);
    return response;
  } catch (error) {
    console.error("Error al cambiar la etapa:", error);
    throw error;
  }
}